// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import { Routes, Route } from 'react-router-dom';
import BudgetHome from './BudgetHome';
import Transactions from '../Transactions';
import Analysis from './Analysis';

export function BudgetRoutes() {
  return (
    <Routes>
      <Route index element={<BudgetHome />} />
      <Route path="/" element={<BudgetHome />} />
      <Route path="transactions" element={<Transactions />} />
      <Route path="analytics" element={<Analysis />} />
    </Routes>
  );
}
